import { ConfigSettingsAddForm } from '@/shared/components/config-settings';
import { PermissionGuard } from '@/features/auth';
import { DealerConfigOptionCombobox } from './DealerConfigOptionCombobox';
import { dealerConfigSettingAddSchema } from '../schemas/dealerConfigSetting.schema';
import type { DealerConfigOption } from '../types/dealerConfigOption.types';
import type { useDealerConfigSettingMutations } from '../hooks/useDealerConfigSettingMutations';

interface Props {
    mutations: ReturnType<typeof useDealerConfigSettingMutations>;
    onDone?: () => void;
    /** Option ids already applied to this dealer; hidden from the search to prevent duplicates. */
    excludeOptionIds?: string[];
}

// Wraps the shared engine with manualEntry (Epic 7.1.4 Decision 4): Key/Data Type stay editable
// with no catalog option selected (config_option_id: null); a selected option derives and locks them.
export function DealerConfigSettingAddForm({ mutations, onDone, excludeOptionIds = [] }: Props) {
    return (
        <ConfigSettingsAddForm<DealerConfigOption>
            schema={dealerConfigSettingAddSchema}
            mutations={mutations}
            onDone={onDone}
            excludeOptionIds={excludeOptionIds}
            manualEntry
            renderCatalogPicker={({ id, value, onChange, excludeIds }) => (
                <PermissionGuard
                    permission={{ resource: 'dealer', action: 'config-option.browse' }}
                    showFallback
                    fallback={(
                        <p className="text-mp-muted text-sm">
                            You do not have access to search the catalog. Enter a key manually below.
                        </p>
                    )}
                >
                    <DealerConfigOptionCombobox
                        id={id}
                        value={value}
                        onChange={onChange}
                        excludeIds={excludeIds}
                        excludeDataTypes={['secret']}
                        placeholder="Search catalog options…"
                    />
                </PermissionGuard>
            )}
        />
    );
}
